import { render, staticRenderFns } from "./consulting.vue?vue&type=template&id=0bfccd0c&scoped=true&"
import script from "./consulting.vue?vue&type=script&lang=js&"
export * from "./consulting.vue?vue&type=script&lang=js&"
import style0 from "./consulting.vue?vue&type=style&index=0&id=0bfccd0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bfccd0c",
  null
  
)

export default component.exports